import * as React from 'react';
import { MainContainer, TableWrapper, TableContainer, TableContent, HeaderRow, HeaderCell, TableBody, BodyRow, BodyCell } from './styles.js';
import { useTable, useSortBy, usePagination, useRowSelect } from 'react-table';
import { Spacing, InlineChildren, Text, Icon } from '@doordash/design-language';
import Toggle from '@doordash/component-toggle';
import { getPropsToForward } from '@doordash/utilities';
import EditableCell from './EditableCell.js';
import TablePagination from './TablePagination.js';
import SkeletonLoader from './SkeletonLoader.js';
import ActionMenu from './ActionMenu.js';

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr && (typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]); if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var getInitialSelection = function getInitialSelection(data, defaultRowSelection) {
  var rowsToSelect = {};

  if (defaultRowSelection) {
    if (defaultRowSelection.id && defaultRowSelection.id instanceof Array) {
      defaultRowSelection.id.forEach(function (element) {
        return rowsToSelect[element] = true;
      });
      delete defaultRowSelection.id;
    }

    if (Object.keys(defaultRowSelection).length > 0) {
      data.forEach(function (row, index) {
        Object.keys(defaultRowSelection).forEach(function (key) {
          if (row[key] === defaultRowSelection[key]) {
            rowsToSelect[index] = true;
          }
        });
      });
    }
  }

  return rowsToSelect;
};

var Table = function Table(_ref) {
  var columns = _ref.columns,
      data = _ref.data,
      allowDataEdit = _ref.allowDataEdit,
      bodyTextProps = _ref.bodyTextProps,
      defaultColumnSort = _ref.defaultColumnSort,
      headerInlineChildrenProps = _ref.headerInlineChildrenProps,
      headerTextProps = _ref.headerTextProps,
      hiddenColumns = _ref.hiddenColumns,
      hiddenHeaders = _ref.hiddenHeaders,
      isSortable = _ref.isSortable,
      numPages = _ref.numPages,
      onCellEdit = _ref.onCellEdit,
      onPageChange = _ref.onPageChange,
      onRowClick = _ref.onRowClick,
      onSort = _ref.onSort,
      rowsPerPage = _ref.rowsPerPage,
      showDataLoading = _ref.showDataLoading,
      tableStyles = _ref.tableStyles,
      currentPage = _ref.currentPage,
      manualPagination = _ref.manualPagination,
      renderBeforePaginationContent = _ref.renderBeforePaginationContent,
      paginationProps = _ref.paginationProps,
      renderPagination = _ref.renderPagination,
      menuItems = _ref.menuItems,
      _onMenuItemClick = _ref.onMenuItemClick,
      showRowSelectionColumn = _ref.showRowSelectionColumn,
      shouldDisableRowSelection = _ref.shouldDisableRowSelection,
      selectedRows = _ref.selectedRows,
      onRowSelect = _ref.onRowSelect,
      defaultRowSelection = _ref.defaultRowSelection,
      props = _objectWithoutProperties(_ref, ["columns", "data", "allowDataEdit", "bodyTextProps", "defaultColumnSort", "headerInlineChildrenProps", "headerTextProps", "hiddenColumns", "hiddenHeaders", "isSortable", "numPages", "onCellEdit", "onPageChange", "onRowClick", "onSort", "rowsPerPage", "showDataLoading", "tableStyles", "currentPage", "manualPagination", "renderBeforePaginationContent", "paginationProps", "renderPagination", "menuItems", "onMenuItemClick", "showRowSelectionColumn", "shouldDisableRowSelection", "selectedRows", "onRowSelect", "defaultRowSelection"]);

  var propsToForward = getPropsToForward({
    props: props,
    prefixesToForward: ['data-', 'aria-']
  });
  var initialRender = React.useRef(true);

  var _React$useState = React.useState({
    rows: [],
    isSelected: false
  }),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      toggledRows = _React$useState2[0],
      setToggledRows = _React$useState2[1];

  var _React$useState3 = React.useState(function () {
    return getInitialSelection(data, defaultRowSelection);
  }),
      _React$useState4 = _slicedToArray(_React$useState3, 2),
      rowSelection = _React$useState4[0],
      setRowSelection = _React$useState4[1];

  React.useEffect(function () {
    if (selectedRows) {
      setRowSelection(selectedRows);
    }
  }, [selectedRows]);
  var displayPagination = rowsPerPage && rowsPerPage > 0;
  var initialState = {};
  var tableContent = {
    columns: columns,
    data: data,
    initialState: initialState
  };

  if (defaultRowSelection || selectedRows) {
    tableContent.initialState.selectedRowIds = rowSelection;
  }

  if (hiddenColumns && hiddenColumns.length) {
    tableContent.initialState.hiddenColumns = hiddenColumns;
  }

  if (defaultColumnSort) {
    tableContent.initialState.sortBy = [{
      id: defaultColumnSort.accessor,
      desc: defaultColumnSort.isDescending
    }];
  }

  if (currentPage) {
    // currentPage is 1-indexed, but pageIndex is 0-indexed.
    tableContent.initialState.pageIndex = currentPage - 1;
  }

  if (manualPagination) {
    tableContent.manualPagination = true;
  }

  var _useTable = useTable(tableContent, useSortBy, usePagination, useRowSelect, function (hooks) {
    if (showRowSelectionColumn) {
      hooks.visibleColumns.push(function (columns) {
        return [// Let's add a column for selection
        {
          id: 'selection',
          disableResizing: true,
          disableSortBy: true,
          columnStyles: {
            column: {
              padding: menuItems && menuItems.length ? "".concat(Spacing.None, "px") : "".concat(Spacing.None, "px ").concat(Spacing.Small, "px"),
              width: "".concat(Spacing.Medium, "px")
            }
          },
          // The header can use the table's getToggleAllRowsSelectedProps method
          // to render a checkbox
          Header: function Header(_ref2) {
            var getToggleAllPageRowsSelectedProps = _ref2.getToggleAllPageRowsSelectedProps,
                rows = _ref2.rows,
                toggleAllPageRowsSelected = _ref2.toggleAllPageRowsSelected,
                _ref2$state = _ref2.state,
                pageIndex = _ref2$state.pageIndex,
                pageSize = _ref2$state.pageSize,
                selectedRowIds = _ref2$state.selectedRowIds;
            var startIndex = pageIndex * pageSize;
            var isSelected = getToggleAllPageRowsSelectedProps().checked;

            if (typeof shouldDisableRowSelection === 'function') {
              var displayedRows = rows.slice(startIndex, startIndex + pageSize);
              var selectedSelectableRows = displayedRows.filter(function (row) {
                return shouldDisableRowSelection(row);
              });
              isSelected = !!(Object.keys(selectedRowIds).length && selectedSelectableRows.every(function (row) {
                return row.isSelected;
              }));
            }

            return /*#__PURE__*/React.createElement(Toggle, {
              label: "Row Selection",
              isSelected: isSelected,
              alignToggle: Toggle.Alignment.Center,
              isLabelHidden: true,
              type: Toggle.Types.Checkbox,
              inputType: Toggle.InputTypes.Checkbox,
              onChange: function onChange(value) {
                var toggledRows = rows.slice(startIndex, startIndex + pageSize);

                if (typeof shouldDisableRowSelection === 'function') {
                  toggledRows = toggledRows.filter(function (row) {
                    return shouldDisableRowSelection(row);
                  });
                }

                toggledRows = toggledRows.map(function (r) {
                  return r.original;
                });
                toggleAllPageRowsSelected(value);
                setToggledRows({
                  rows: toggledRows,
                  isSelected: value
                });
              }
            });
          },
          // The cell can use the individual row's getToggleRowSelectedProps method
          // to render a checkbox
          Cell: function Cell(_ref3) {
            var row = _ref3.row;
            return /*#__PURE__*/React.createElement(Toggle, {
              label: "Row Selection",
              isSelected: row.isSelected,
              alignToggle: Toggle.Alignment.Center,
              isLabelHidden: true,
              isDisabled: typeof shouldDisableRowSelection === 'function' ? !shouldDisableRowSelection(row) : false,
              type: Toggle.Types.Checkbox,
              inputType: Toggle.InputTypes.Checkbox,
              onChange: function onChange(value) {
                row.toggleRowSelected(value);
                setToggledRows({
                  rows: [row.original],
                  isSelected: value
                });
              }
            });
          }
        }].concat(_toConsumableArray(columns));
      });
    }

    if (menuItems && menuItems.length) {
      hooks.visibleColumns.push(function (columns) {
        return [{
          id: 'menu',
          disableResizing: true,
          disableSortBy: true,
          columnStyles: {
            column: {
              padding: "".concat(Spacing.None),
              width: "".concat(Spacing.Medium, "px")
            }
          },
          Header: function Header() {
            return null;
          },

          /**
           * selectedFlatRows here is an instance property that react-table provides,
           * it holds the array of rows that are currently selected.
           * refer react-table docs for more details: https://react-table.tanstack.com/docs/api/useRowSelect#instance-properties
           */
          Cell: function Cell(_ref4) {
            var row = _ref4.cell.row,
                rows = _ref4.rows,
                selectedFlatRows = _ref4.selectedFlatRows;
            return /*#__PURE__*/React.createElement(ActionMenu, {
              row: row,
              selectedRows: selectedFlatRows.map(function (row) {
                return row.original;
              }),
              menuItems: menuItems,
              toggleRowSelection: function toggleRowSelection() {
                if (onRowSelect && !row.isSelected) row.toggleRowSelected();
                rows.map(function (rowItem) {
                  rowItem.isMenuOpen = rowItem.id === row.id;
                  return rowItem;
                });
              },
              onMenuItemClick: function onMenuItemClick(action) {
                _onMenuItemClick(action, row.original, selectedFlatRows.map(function (row) {
                  return row.original;
                }));
              },
              menuContainerStyles: tableStyles && tableStyles.menuContainer
            });
          }
        }].concat(_toConsumableArray(columns));
      });
    }

    hooks.useControlledState = function (state) {
      return _objectSpread(_objectSpread({}, state), {}, {
        selectedRowIds: rowSelection
      });
    };

    hooks.stateReducers.push(function (state, action, _previousState, instance) {
      if (action.type === 'toggleRowSelected') {
        if (rowSelection.hasOwnProperty(action.id)) {
          var newRowSelection = _objectSpread({}, rowSelection);

          delete newRowSelection[action.id];
          setRowSelection(newRowSelection);
        } else {
          setRowSelection(function (prevRows) {
            return _objectSpread(_objectSpread({}, prevRows), {}, _defineProperty({}, action.id, true));
          });
        }
      }

      if (action.type === 'toggleAllPageRowsSelected') {
        var _action$value;

        var value = (_action$value = action.value) !== null && _action$value !== void 0 ? _action$value : !instance.isAllPageRowsSelected;
        var _pageIndex = state.pageIndex,
            _pageSize = state.pageSize;
        var startIndex = _pageIndex * _pageSize;
        var rowsToSelect = instance.rows.slice(startIndex, startIndex + _pageSize).map(function (r) {
          return r.id;
        });

        if (typeof shouldDisableRowSelection === 'function') {
          var rowsToToggle = instance.rows.slice(startIndex, startIndex + _pageSize);
          rowsToSelect = rowsToToggle.filter(function (row) {
            return shouldDisableRowSelection(row);
          }).map(function (r) {
            return r.id;
          });
        }

        if (value) {
          var newSelectedRowIds = rowsToSelect.reduce(function (prev, curr) {
            return _objectSpread(_objectSpread({}, prev), {}, _defineProperty({}, curr, value));
          }, {});
          setRowSelection(function (prevRows) {
            return _objectSpread(_objectSpread({}, prevRows), newSelectedRowIds);
          });
        } else {
          var _newRowSelection = _objectSpread({}, rowSelection);

          rowsToSelect.forEach(function (id) {
            delete _newRowSelection[id];
          });
          setRowSelection(_newRowSelection);
        }
      }
    });
  }),
      getTableProps = _useTable.getTableProps,
      getTableBodyProps = _useTable.getTableBodyProps,
      headerGroups = _useTable.headerGroups,
      prepareRow = _useTable.prepareRow,
      page = _useTable.page,
      _useTable$state = _useTable.state,
      pageIndex = _useTable$state.pageIndex,
      pageSize = _useTable$state.pageSize,
      sortBy = _useTable$state.sortBy,
      selectedRowIds = _useTable$state.selectedRowIds,
      pageCount = _useTable.pageCount,
      gotoPage = _useTable.gotoPage,
      setPageSize = _useTable.setPageSize,
      rows = _useTable.rows;

  React.useEffect(function () {
    onSort && onSort(sortBy);
  }, [onSort, sortBy]); // Storing onRowSelect in a ref so changes do not trigger a re-render. If onRowselect is added to the dependency array of useEffect,
  // a consumer may need to wrap their function in useCallback before passing it to the Table component. Otherwise it will likely trigger
  // the "Maximum update depth exceeded" error. This is because the consuming component would likely re-render after running onRowSelect,
  // which then passes a new onRowSelect function to Table, which will cause Table to re-run onRowSelect because it's in the dependency array,
  // which re-renders the parent, etc. etc.

  var onRowSelectRef = React.useRef(null); // Update the callback ref if onRowSelect changes

  React.useEffect(function () {
    onRowSelectRef.current = onRowSelect;
  }, [onRowSelect]); // If toggledRows is in the dependency array of the useEffect below, it triggers an infinite loop because we are resetting the state
  // within the useEffect hook. By storing the toggledRows state in a ref, the useEffect hook always has access to the
  // latest state (since we update the ref whenever toggledRows changes in a different useEffect) without requiring the
  // value to be tracked in the dependency array, freeing us to reset the state within the hook

  var toggledRowsRef = React.useRef(null); // Update the toggledRow ref if state changes

  React.useEffect(function () {
    toggledRowsRef.current = toggledRows;
  }, [toggledRows]);
  React.useEffect(function () {
    if (!initialRender.current && onRowSelectRef && onRowSelectRef.current && typeof onRowSelectRef.current === 'function') {
      var rowIds = Object.keys(selectedRowIds);
      var toggled = toggledRowsRef.current; // Bubble up the selection to the parent component

      onRowSelectRef.current(data.filter(function (_, index) {
        return rowIds.includes(index.toString());
      }), rows.filter(function (row) {
        return rowIds.includes(row.id.toString());
      }), toggled ? toggled.rows : undefined, toggled ? toggled.isSelected : undefined, rowSelection);
      setToggledRows({
        rows: [],
        isSelected: false
      });
    }
  }, [selectedRowIds, data, rows, rowSelection]);
  React.useEffect(function () {
    if (displayPagination) {
      setPageSize(rowsPerPage);
    } else if (data.length && pageSize !== data.length) {
      setPageSize(data.length);
    }
  }, [rowsPerPage, displayPagination, data, setPageSize, pageSize]); // Set initialRender to true at end of initial rendering

  React.useEffect(function () {
    if (initialRender.current == true) {
      initialRender.current = false;
    }
  }, []);
  return /*#__PURE__*/React.createElement(MainContainer, propsToForward, /*#__PURE__*/React.createElement(TableWrapper, {
    customStyles: tableStyles && tableStyles.tableWrapper
  }, /*#__PURE__*/React.createElement(TableContainer, {
    customStyles: tableStyles && tableStyles.tableContainer
  }, /*#__PURE__*/React.createElement(TableContent, getTableProps(), /*#__PURE__*/React.createElement("thead", null, headerGroups.map(function (headerGroup, headerGroupIndex) {
    return /*#__PURE__*/React.createElement(HeaderRow, _extends({
      key: "header-row-".concat(headerGroupIndex),
      customStyles: tableStyles && tableStyles.headerRow
    }, headerGroup.getHeaderGroupProps()), headerGroup.headers.map(function (column, columnIndex) {
      var customStyles = {};

      if (tableStyles) {
        customStyles = _objectSpread(_objectSpread({}, customStyles), tableStyles.headerCells);
      }

      if (column.columnStyles) {
        customStyles = _objectSpread(_objectSpread(_objectSpread({}, customStyles), column.columnStyles.column), column.columnStyles.header);
      }

      if (hiddenHeaders && hiddenHeaders.indexOf(column.id) > -1) {
        return /*#__PURE__*/React.createElement(HeaderCell, {
          key: column.id,
          customStyles: customStyles
        });
      }

      return /*#__PURE__*/React.createElement(HeaderCell, _extends({
        key: "header-cell-".concat(columnIndex)
      }, column.getHeaderProps( // Setting title as undefined overrides the default library behavior to ensure
      // we aren't displaying an untranslated native browser "tooltip" when
      // the header is hovered over (see https://doordash.atlassian.net/browse/PRIWEB-374)
      isSortable ? column.getSortByToggleProps({
        title: undefined
      }) : undefined), {
        customStyles: customStyles
      }), /*#__PURE__*/React.createElement(InlineChildren, _extends({
        alignItems: InlineChildren.Alignment.Center,
        size: InlineChildren.Sizes.XxSmall
      }, headerInlineChildrenProps, column.headerInlineChildrenProps), ['menu', 'selection'].includes(column.id) ? column.render('Header') : null, _typeof(column.name) === 'object' ? column.name : /*#__PURE__*/React.createElement(Text, _extends({
        styles: Text.Styles.TableMediumHeader
      }, headerTextProps, column.headerTextProps), column.name), isSortable && !column.disableSortBy && (column.isSorted ? column.isSortedDesc ? /*#__PURE__*/React.createElement(Icon, {
        shouldAdjustSmallSizesWhitespace: true,
        size: Icon.Sizes.Small,
        type: Icon.Types.ArrowDown,
        color: Icon.Colors.TextHighlight
      }) : /*#__PURE__*/React.createElement(Icon, {
        shouldAdjustSmallSizesWhitespace: true,
        size: Icon.Sizes.Small,
        type: Icon.Types.ArrowUp,
        color: Icon.Colors.TextHighlight
      }) : /*#__PURE__*/React.createElement(Icon, {
        shouldAdjustSmallSizesWhitespace: true,
        size: Icon.Sizes.Small,
        type: Icon.Types.SortOrder,
        color: Icon.Colors.TextTertiary
      }))));
    }));
  })), !showDataLoading ? /*#__PURE__*/React.createElement(TableBody, _extends({
    customStyles: tableStyles && tableStyles.body
  }, getTableBodyProps()), page.map(function (row, rowIndex) {
    prepareRow(row);
    return /*#__PURE__*/React.createElement(BodyRow, _extends({
      key: "row-".concat(rowIndex)
    }, row.getRowProps(), {
      onClick: function onClick() {
        return onRowClick && onRowClick(row.values, row, rows);
      },
      isSelected: row.isSelected,
      customStyles: tableStyles && {
        row: tableStyles.row,
        rowHovered: tableStyles.rowHovered,
        rowPressed: tableStyles.rowPressed,
        rowSelected: tableStyles.rowSelected
      }
    }), row.cells.map(function (cell, cellIndex) {
      var customStyles = {};

      if (tableStyles) {
        customStyles = _objectSpread(_objectSpread({}, customStyles), tableStyles.dataCells);
      }

      if (cell.column && cell.column.columnStyles) {
        customStyles = _objectSpread(_objectSpread(_objectSpread({}, customStyles), cell.column.columnStyles.column), cell.column.columnStyles.data);
      }

      if ((allowDataEdit || cell.column && cell.column.allowDataEdit) && _typeof(cell.value) !== 'object') {
        return /*#__PURE__*/React.createElement(EditableCell, {
          onCellEdit: onCellEdit && onCellEdit,
          originalValue: cell.value.toString(),
          originalRowInformation: row.values,
          rowIndex: rowIndex,
          columnId: cell.column.id,
          cellProps: _objectSpread({}, cell.getCellProps()),
          key: "".concat(rowIndex, "-").concat(cell.value, "-").concat(cell.column.id),
          customStyles: customStyles,
          bodyTextProps: bodyTextProps
        });
      }

      return /*#__PURE__*/React.createElement(BodyCell, _extends({
        key: "body-cell-".concat(cellIndex),
        customStyles: customStyles
      }, cell.getCellProps()), _typeof(cell.value) !== 'object' ? /*#__PURE__*/React.createElement(Text, _extends({
        styles: Text.Styles.TableMediumBody
      }, bodyTextProps, cell.column.bodyTextProps), cell.render('Cell')) : cell.render('Cell'));
    }));
  })) : /*#__PURE__*/React.createElement(TableBody, {
    customStyles: tableStyles && tableStyles.body
  }, /*#__PURE__*/React.createElement(SkeletonLoader, {
    numColumns: columns.length,
    numRows: rowsPerPage || 5,
    cellStyles: tableStyles && tableStyles.dataCells,
    rowStyles: tableStyles && {
      row: tableStyles.row,
      rowHovered: tableStyles.rowHovered,
      rowPressed: tableStyles.rowPressed
    }
  }))))), displayPagination || renderBeforePaginationContent ? /*#__PURE__*/React.createElement(TablePagination, {
    rows: rows,
    rowsPerPage: rowsPerPage,
    pageIndex: pageIndex,
    pageCount: pageCount,
    numPages: numPages,
    onPageChange: onPageChange,
    gotoPage: gotoPage,
    renderBeforePaginationContent: renderBeforePaginationContent,
    containerStyles: tableStyles && tableStyles.paginationWrapper,
    paginationProps: paginationProps,
    renderPagination: renderPagination
  }) : null);
};

Table.defaultProps = {
  allowDataEdit: false,
  isSortable: true,
  showDataLoading: false,
  manualPagination: false
};

export { Table as default };
